<div class="">
    <div class="row d-flex flex-column ">

        <div class="text-center">
            <h2 class="orange-header">You're done!</h2>
            <p>Time to level up your payments and get paid in a snap! </p>
        </div>

        <div class="col-2 d-flex justify-content-center mb-4 justify-content-center align-self-center">
            <img [ngSrc]="'snapping-fingers.gif' | assetSource"
                 alt="snapping fingers gif"
                 class="walkthrough-image responsive-gif"
                 height="1"
                 width="1"/>
        </div>

    </div>
</div>